<template>
  <div>
    <page-header
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
      :page="page"
      :actions="headerActions"
    />
    <filter-manager
      ref="filter"
      class="filter-manager_extended"
      search-container-class="search-btn"
      v-model="filter.model"
      :filters="filtersHeader"
      @search="onSearchHandler()"
    />
    <custom-separator
      class="my-3 custom-separator"
      text="Resultado de la Solicitudes"
    />
    <div v-if="hasResults">
      <result-row
        v-for="(item, index) in results"
        :key="index"
        :item="item"
        @open="handlerOpen"
        @close="handlerClose"
        @refresh="refresh"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onPageChange"
      />
    </div>
    <custom-result-not-found v-else text="No hay Información Disponible." />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import inventoryService from '@/services/api/inventorycatalog.api';
import locationService from '@/services/api/location.api';

import { options as InventoryTypes } from '@/utils/constants/purchaseMethodInventoryTypes';

import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
const MODULE_NAME = 'EquipmentTranferRequestHandling';
import ResultRow from './components/ResultRow';
const DEFAULT_PAGE_SIZE = 10;
export default {
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    ResultRow,
    Pagination,
  },
  mixins: [storeMixin],
  data() {
    return {
      moduleName: MODULE_NAME,
      results: [],
      filter: {
        model: {
          equipment: null,
          status: null,
          requestNumberOrItemCode: null,
          requestDate: null,
          inventoryType: null,
          caat: null,
        },
        options: {
          equipments: [],
          statuses: [],
          inventoryTypes: InventoryTypes,
          caats: [],
        },
      },
      pagination: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    };
  },
  computed: {
    page() {
      return {
        icon: 'fas fa-laptop',
        title: 'Manejo de Solicitudes de Transferencia de Equipos',
        routes: [
          'Asistencia Tecnológica',
          'Inventario',
          'Manejo de Solicitudes de Transferencia de Equipos',
        ],
      };
    },
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'inventory' }),
        },
      ];
    },
    filtersHeader() {
      return [
        {
          name: 'equipment',
          component: 'CustomDropDown',
          value: this.filter.model.equipment,
          options: this.filter.options.equipments,
          placeholder: 'Nombre de Equipo',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          classContainer: 'w-100',
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          value: this.filter.model.status,
          options: this.filter.options.statuses,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          classContainer: 'w-100',
        },
        {
          name: 'requestNumberOrItemCode',
          component: 'CustomInput',
          value: this.filter.model.requestNumberOrItemCode,
          placeholder: 'Escriba Número de Solicitud o Código de Equipo',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-12 col-md',
          type: 'text',
        },
        {
          name: 'requestDate',
          label: 'Fecha de Solicitud:',
          component: 'CustomDatePicker',
          value: this.filter.model.requestDate,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          classContainer: 'w-100',
          isAdvanced: true,
        },
        {
          name: 'inventoryType',
          label: 'Tipo de Inventario:',
          component: 'CustomDropDown',
          value: this.filter.model.inventoryType,
          options: this.filter.options.inventoryTypes,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
        },
        {
          name: 'caat',
          label: 'CAAT:',
          component: 'CustomDropDown',
          value: this.filter.model.caat,
          options: this.filter.options.caats,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
          disabled: this.filter.options.caats?.length === 1,
        },
      ];
    },
    hasResults() {
      return Boolean(this.results.length);
    },
  },
  async mounted() {
    await Promise.all([
      this.getEquipments(),
      this.getStatuses(),
      this.getCaats(),
    ]);
  },
  methods: {
    async getEquipments() {
      const { data } = await inventoryService.getAllEquipmentsRequested();
      this.filter.options.equipments = data;
      if (data.length === 1) this.filter.model.equipment = data[0];
    },
    async getStatuses() {
      const { data } = await inventoryService.getTransferStatuses();
      this.filter.options.statuses = data;
      if (data.length === 1) this.filter.model.status = data[0];
    },
    async getCaats() {
      const { data } = await locationService.getCaats();
      this.filter.options.caats = data;
      if (data.length == 1) {
        this.filter.model.caat = data[0];
      }
    },
    async onSearchHandler(page = 1) {
      var payload = {
        caatId: this.filter.model.caat?.id,
        catalogId: this.filter.model.equipment?.id,
        inventoryType: this.filter.model.inventoryType?.id,
        requestNumberOrItemCode: this.filter.model.requestNumberOrItemCode,
        requestDate: this.filter.model.requestDate,
        statusId: this.filter.model.status?.id,
        currentPage: page,
        pageSize: DEFAULT_PAGE_SIZE,
      };
      var { data } = await inventoryService.searchTranfers(payload);
      this.results = data.data.map((x) => ({ ...x, isOpen: false }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async onPageChange(page) {
      this.onSearchHandler(page);
    },
    handlerOpen(item) {
      this.results
        .filter((x) => x.id !== item.id && x.isOpen)
        .forEach((x) => (x.isOpen = false));
      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
    },
    refresh() {
      this.onSearchHandler(this.pagination.currentPage);
    },
  },
};
</script>

<style></style>
